import React from "react";
import EventsSection from "../../components/eventCards/EventsSection";

function Events() {
  return (
    <>
      {/* Events Banner */}
      <section className="events-banner-section">
        <div className="blur-overlay"></div>
        <div className="container-fluid">
          <div className="events-banner-content">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <h1 className="events-banner-title text-white">Discover Amazing Events</h1>
                <p className="events-banner-subtitle text-white">
                  Find and book tickets for the most exciting events happening around you
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Events Grid */}
      <section className="container-fluid container-xxl px-md-5 my-5">
        <div className="row">
          <EventsSection title="" showAsGrid={true} />
        </div>
      </section>
    </>
  );
}

export default Events;